import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
query Users($search: String, $tagIds: [Int!]) {
  users(search: $search, tagIds: $tagIds) {
    photoUrl
    identifier
    name
    id
    preferredName
    scriptName
    tags {
        id
        name
    }
  }
}`;
